import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=a15ac392"
import script from "./modal.ts?vue&type=script&lang=ts&external"
export * from "./modal.ts?vue&type=script&lang=ts&external"
import style0 from "./modal.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports